import Vue from 'vue'
import './plugins/axios'
import vuetify from './plugins/vuetify'
import './plugins/vue-beautiful-chat'
import './plugins/vee-validate'
import './plugins/vue-card-payment'
import './plugins/vue-meta'
import './plugins/vue-head'
import 'codemirror/lib/codemirror'
import 'codemirror/mode/python/python'
import 'codemirror/mode/javascript/javascript'
import router from '@/router/router.js'
import App from './components/App.vue'
import VueAnalytics from 'vue-analytics'
import store from './store/store.js'
import firebase from 'firebase/app'
globalThis.firebase = firebase

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-152384574-1',
  router
})

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
